module.exports = __webpack_public_path__ + "static/hero-01-f52ae0163cb7837fa69a4634c8f8699e.jpg";